import type {
  CabinetRoleEditorView,
  CopyRoleRequest,
  DeleteRoleRequest,
  ListRoleEditorResult,
  UpdateRoleRequest,
} from "@planerius/contracts/cabinet-auth"

import { apiRequest } from "./http"

/**
 * Редактор ролей (4-Б11) — право roles.manage, то есть владелец. Окно приглашения берёт
 * роли другим запросом (invitations.api.ts, listRoles): там нужен ответ «что можно выдать»,
 * здесь — роли целиком, с людьми на них.
 */
export function listRoleEditor(signal?: AbortSignal): Promise<ListRoleEditorResult> {
  return apiRequest("/cabinet/roles/editor", { signal })
}

export function copyRole(request: CopyRoleRequest): Promise<CabinetRoleEditorView> {
  return apiRequest("/cabinet/roles/copy", { method: "POST", body: request })
}

export function updateRole(request: UpdateRoleRequest): Promise<CabinetRoleEditorView> {
  return apiRequest("/cabinet/roles/update", { method: "POST", body: request })
}

export function deleteRole(request: DeleteRoleRequest): Promise<void> {
  return apiRequest("/cabinet/roles/delete", { method: "POST", body: request })
}
